export const DROPDOWN_LIST_RELATIONS = 'DROPDOWN_LIST_RELATIONS'
export const DROPDOWN_LIST_RELATIONS_SUCCESS = 'DROPDOWN_LIST_RELATIONS_SUCCESS'
export const DROPDOWN_LIST_RELATIONS_FAILED = 'DROPDOWN_LIST_RELATIONS_FAILED'
